module.exports = __webpack_public_path__ + "static/slide4.7ee854bb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide4.jpeg
// module id = 1706
// module chunks = 173894859265406